import { render, staticRenderFns } from "./LiveCategoryForm.vue?vue&type=template&id=3fa15d25"
import script from "./LiveCategoryForm.vue?vue&type=script&lang=js"
export * from "./LiveCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports